<div class="confirm-typed-address">
  <header class="pb-3 mb-4 border-bottom">
    <h2 class="modal-title mb-1">Confirm your delivery address</h2>
    <p class="m-0 text-muted">Review the recommended changes</p>
  </header>

  <!-- Plain text, not a card: it is there to compare against, not to pick. -->
  <p class="entered mb-3">
    <span class="entered__label">What you entered:</span> {{ data().entered }}
  </p>

  <section class="address-card address-card--recommended mb-4">
    <p class="address-card__label">Recommended</p>
    <p class="m-0">{{ data().recommended }}</p>

    @if (!mapFailed()) {
    <div class="address-card__map mt-3">
      <div class="address-card__map-canvas" #map></div>
      <i class="fas fa-location-dot address-card__pin" aria-hidden="true"></i>
      <a class="address-card__maps-link" [href]="mapsUrl()" target="_blank" rel="noopener">
        Maps <i class="fas fa-arrow-up-right-from-square ms-1" aria-hidden="true"></i>
      </a>
    </div>
    }
  </section>

  <div class="d-flex justify-content-center gap-4">
    <button type="button" class="btn btn-outline-primary rounded-pill w-100 py-3" (click)="back()">Back</button>
    <button type="button" class="btn btn-primary rounded-pill w-100 py-3" (click)="confirm()">Confirm</button>
  </div>
</div>
